import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/default/default-style.scss';
import Header from '@png/npm-header';
import SelectDropdown from '@png/npm-select-dropdown';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/address-lookup';
import ClearCache from '../../modules/clear-cache';
import CookieBar from '../../modules/cookie-bar';
import Incrementer from '../../modules/incrementer';
import Impersonate from '../../modules/impersonate';
import LightGallery from '../../modules/light-gallery';
import Popup from '../../modules/popup';
import Pagination from '../../modules/pagination';
import Toast from '../../modules/toast';
import RealTimePrice from '../../modules/real-time-price';
import RealTimeStock from '../../modules/real-time-stock';
import SmoothScroll from '../../modules/smooth-scroll';
import SaveShoppingCart from '../../modules/save-shopping-cart';
import ProductFavorite from '../../modules/product-favorite';
import PreviousPage from '../../modules/previous-page';
import Recaptcha from '../../modules/recaptcha';
import FilterTags from '../../modules/filter-tags';
import VoiceToSearch from '../../modules/voice-to-search';
import SoundwaveVisualizer from '../../modules/soundwave-visualizer';
import DataLayerController from '../../modules/DataLayerController';
import StockLocationSearch from '../../modules/StockLocationSearch';
import StockLocationAddToCart from '../../modules/StoreLocationAddToCart';
import AddBreakTooltip from '../../modules/add-break-tooltip';
import NativeApp from '../../modules/native-app';
import StockNotificationMailer from '../../modules/stock-notification-mailer';
import ActivityPusher from '../../modules/activity-pusher';
import KvkCheck from '../../modules/kvk-check';
// import PreviouslyOrderedOverview from '../../modules/PreviouslyOrderedOverview';
import SearchProducts from '../../modules/search-products';
import ReadMoreLess from '../../modules/read-more-less';
import LocatorA from '../../modules/LocatorA';

document.addEventListener('DOMContentLoaded', () => {
  const modules = [
    new ReadMoreLess(),
    new SearchProducts(),
    new VoiceToSearch(),
    new SoundwaveVisualizer(),
    new ActivityPusher(),
    new AddBreakTooltip(),
    new StockLocationSearch(),
    new StockLocationAddToCart(),
    new DataLayerController(),
    new FilterTags(),
    new Recaptcha({
      key: '6LfT6_wcAAAAAH_YVfNgqxo7J6obe0Qh7OyyjL0e'
    }),
    new Header({
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false
    }),
    new RealTimePrice(),
    new RealTimeStock(),
    new Incrementer(),
    new Pagination(),
    new Popup(),
    new SvgIcon(),
    new Impersonate(),
    new ProductFavorite(),
    new SelectDropdown(),
    new CookieBar(),
    new LightGallery(),
    new SmoothScroll(),
    new AddressLookup(),
    new ClearCache(),
    new NativeApp(),
    new Toast({
      duration: 3000,
      close: true
    }),
    new SaveShoppingCart(),
    new StockNotificationMailer(),
    new PreviousPage(),
    new KvkCheck(),
    new LocatorA()
    // new PreviouslyOrderedOverview()
  ];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });
});

window.addEventListener('retriggerRealtime', () => {
  const modules = [new RealTimePrice(), new RealTimeStock(), new Incrementer(), new SvgIcon()];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });
});
